'use strict';

angular.module('buyers')
.directive('propertyPosts', ['$rootScope', '$sce', 'BuyerService', 'PostService', function($rootScope, $sce, BuyerService, PostService) {
    return {
        templateUrl : "partials/property-posts.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'property': '='
        },
        link : function (scope, element, attrs) {
            scope.propertyPosts = [];
            var getPosts = function() {
                $rootScope.loading = true;
                var filter = {
                    filterType: 'propertyRelated',
                    propertyRef: scope.property.propertyRef
                };

                PostService.getPosts(filter,10, 0).then(function(response) {
                    var i=0;
                    if(response.length > 0) {
                        // $scope.page = $scope.page + 1;
                         angular.forEach(response, function(rs) {
                            try{
                                // $scope.showBeforePostId = rs.id;
                                rs.data = JSON.parse(rs.data);
                                rs.data.htmlMessage = $sce.trustAsHtml(rs.data.message);
                                rs.data.videoUrlFull = '';
                                if(rs.data.videoUrl !== undefined && rs.data.videoUrl != '') {
                                    rs.data.videoUrlFull = 'http://www.youtube.com/embed/' + rs.data.videoUrl;
                                    rs.data.videoUrlFull = $sce.trustAsResourceUrl(rs.data.videoUrlFull);
                                }
                            }catch(e){
                                console.log(e);
                                rs.data = {};
                            }
                            rs.ref = rs.id * 12569;
                            scope.propertyPosts.push(rs);
                            i++;
                        });
                    }
                }).finally( function(){
                    $rootScope.loading = false;
                });
            }

            getPosts();

        }
    };
}]);